import { getSubDomain } from '../../common/functions/get-subdomain';
import { isDev } from './is-dev';
import { isStaging } from './is-staging';

export const getApiUrlFromWindowLocation = () => {
  const subdomain = getSubDomain(window.location.hostname);
  const isTrial = subdomain === 'trial';

  if (isTrial) {
    if (isDev) return `http://${window.location.hostname.replace('trial.', '')}:4002`;
  }

  if (isDev) return `http://${window.location.hostname}:4002`;
  if (isStaging) return `${window.location.protocol}//api.staging.volaby.org`;
  return `${window.location.protocol}//api.volaby.org`;
};
